<template>
  <donut-form-item
    label="Snooze Settings"
    description="Configure when you want to pause notifications and meetings"
    :left-align="true"
  >
    <donut-button
      v-if="!loading && snoozedAll && !dateEnd"
      @click="unsnoozeAll"
    >
      Stop snoozing all intros
    </donut-button>
    <donut-datepicker
      v-else
      v-model="dateEnd"
      :clear-btn="true"
      placeholder="Snooze all intros until..."
      format="M d, yyyy"
      :disabled="loading"
      :loading="loading"
      :update-action="handleDateChange"
    />
  </donut-form-item>
</template>

<script setup>
import { computed, onMounted } from 'vue';
import { useStore } from 'vuex';
import * as moment from 'moment';

const { state, dispatch, getters, commit } = useStore();

const dateEnd = computed({
  get: () => {
    const endDate = getters['snoozeIntros/snoozeAllEndDate'];

    if (!endDate) {
      return '';
    }

    // Parse the ISO date and format it without timezone conversion
    return moment.utc(endDate).format('MMM D, YYYY');
  },
  set: (value) => {
    if (!value) {
      commit('snoozeIntros/update', { key: 'snoozeAllEndDate', value: '' });
    } else {
      // Parse the date correctly to avoid moment.js deprecation warning
      const parsedDate = moment(value, 'MMM D, YYYY');
      commit('snoozeIntros/update', { key: 'snoozeAllEndDate', value: parsedDate.toISOString() });
    }
  },
});

const loading = computed(() => getters['snoozeIntros/loading']);
const snoozedAll = computed(() => getters['snoozeIntros/snoozedAll']);

const handleDateChange = (value) => {
  if (loading.value) return;

  window.mixpanel.track('User Web Settings - Snooze Intros - Snooze All Until', {
    snooze_all_until: value,
  });
  if (!value || value === '') {
    dispatch('snoozeIntros/destroyAllSnooze', state.currentUser.id);
  } else {
    // Convert the date from "Aug 22, 2025" format to ISO format
    const formattedDate = moment(value, 'MMM D, YYYY').toISOString();
    dispatch('snoozeIntros/bulkUpdateSnooze', {
      userId: state.currentUser.id,
      endDate: formattedDate,
    });
  }
};

const unsnoozeAll = () => {
  if (loading.value) return;

  dispatch('snoozeIntros/destroyAllSnooze', state.currentUser.id);
};

onMounted(() => {
  dispatch('snoozeIntros/fetchSnoozeStatus', state.currentUser.id);
});
</script>
